import * as React from 'react';
import { Header1 } from '@cian/ui-kit';

import { IAdvantage } from '../../types/newbuilding/advantages';
import { Layout } from '../Layout';
import { VerticalSliderFullscreen } from '../VerticalSlider';
import { AdvantageItem } from './components/AdvantageItem';

import * as styles from './styles.css';

interface IAdvantagesProps {
  advantages: IAdvantage[];
  onItemClick(i: number): void;
}

export function Advantages({ advantages, onItemClick }: IAdvantagesProps) {
  return (
    <div>
      <Layout>
        <div className={styles['header']}>
          <Header1 as="h2" fontWeight="bold">
            Особенности комплекса
          </Header1>
        </div>
      </Layout>
      <div className={styles['container']}>
        <VerticalSliderFullscreen onItemClick={onItemClick}>
          {advantages.map(({ title, images }) => (
            <AdvantageItem key={title} title={title} imgUrl={images[0]?.url} />
          ))}
        </VerticalSliderFullscreen>
      </div>
    </div>
  );
}
